import React, { ReactElement, useContext } from "react";
import { ActionType } from "../../../AppDataProvider/actions";
import { AppContext } from "../../../AppDataProvider/AppDataProvider";
import { Button } from "../index";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { marginRight } from "../../styles";
import { Mixpanel } from "../../../mixpanel/mixpanel";
import styled from "styled-components";
import { supportedLanguages } from "../../../i18n";
import { useTranslation } from "react-i18next";
export { supportedLanguages } from "../../../i18n";
export function LanguageSelector(): ReactElement {
  const {
    t,
    i18n
  } = useTranslation();
  const {
    appDataDispatch
  } = useContext(AppContext);
  const onSelectLanguage = async (newLanguage: string) => {
    appDataDispatch({
      type: ActionType.HIDE_NON_MODAL_DIALOG
    });
    Mixpanel.track({
      name: "Changed language",
      props: {
        from: i18n.language,
        to: newLanguage
      }
    });
    await i18n.changeLanguage(newLanguage);
  };
  const selectedLanguage = supportedLanguages.find(({
    value
  }) => {
    return value === i18n.language;
  });
  const language = selectedLanguage ? selectedLanguage.value : "en-GB";
  return <LanguageList data-sentry-element="LanguageList" data-sentry-component="LanguageSelector" data-sentry-source-file="LanguageSelector.tsx">
      {supportedLanguages.map(supportedLanguage => {
      const selected = supportedLanguage.value === language;
      const ariaLabel = selected ? t("selectedLanguageAriaLabel", {
        language: supportedLanguage.label
      }) : t("selectLanguageAriaLabel", {
        language: supportedLanguage.label
      });
      return <Button variant="tertiary" key={supportedLanguage.value} aria-label={ariaLabel} role="button" onClick={() => {
        void onSelectLanguage(supportedLanguage.value);
      }}>
            {selected && <SelectedLanguageIcon />}
            {supportedLanguage.label}
          </Button>;
    })}
    </LanguageList>;
}
const LanguageList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
const SelectedLanguageIcon = styled(FontAwesomeIcon).attrs({
  icon: faCheck
})`
  ${marginRight.s}
`;
export default LanguageSelector;